import { render, staticRenderFns } from "./GroupDetailView.vue?vue&type=template&id=5276d600&scoped=true"
import script from "./GroupDetailView.vue?vue&type=script&lang=js"
export * from "./GroupDetailView.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailView.vue?vue&type=style&index=0&id=5276d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276d600",
  null
  
)

export default component.exports